/** Remove invalid characters for query selectors and class names */
export const sanitizeClassName = (className: string): string =>
  className.replace(/\|/g, '-')
